export default {
      id: "Icon--region-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--region",
      toString: function () {
        return this.url;
      }
    }